module.exports = __webpack_public_path__ + "static/media/m3ssilver.f491ba2f.png";